import React, { useState, useEffect } from "react";
import { NavLink, Link } from "react-router-dom";
import "./Header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsMenuOpen, setProductsMenuOpen] = useState(false);

  // --- IMPORTANTE: Reintegrado para el bloqueo de scroll ---
  useEffect(() => {
    if (menuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    return () => {
      document.body.classList.remove('no-scroll');
    };
  }, [menuOpen]);

  useEffect(() => {
    if (!menuOpen) {
      setProductsMenuOpen(false);
    }
  }, [menuOpen]);

  const handleProductsClick = (e) => {
    if (window.innerWidth <= 992) {
      e.preventDefault();
      setProductsMenuOpen(!productsMenuOpen);
    } else {
      setMenuOpen(false);
    }
  };
  
  const handleLinkClick = () => {
    setProductsMenuOpen(false);
    setMenuOpen(false);
  };

  const handleWhatsAppClickHeader = () => {
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'click', { 'event_category': 'Contacto', 'event_label': 'Boton_WhatsApp_Header' });
    }
  };
  
  const productos = [
    { path: "/LandingPage/Estaciones-de-servicio", label: "Estaciones de Servicio" },
    { path: "/productos/estacionamientos", label: "Estacionamientos" },
    { path: "/productos/colectivos", label: "Colectivos" },
    { path: "/productos/mercado_de_valores", label: "Mercado de Valores" },
    { path: "/productos/farmacias", label: "Farmacias" },
    { path: "/productos/tarifadores", label: "Tarifadores" },
    { path: "/productos/fecha_y_hora", label: "Fecha y Hora" },
    { path: "/productos/turneros", label: "Turneros" },
    { path: "/productos/textoPasante", label: "Texto Pasante" },
  ];

  return (
    <header>
      <nav>
        <NavLink className="aimgnav" to="/" onClick={handleLinkClick}>
          <img src="/Assets/Microled-Mati-Calvier.svg" alt="Logo Microled" title="Logo Microled" />
        </NavLink>

        <ul className={`links ${menuOpen ? "active" : ""}`}>
          <li>
            <NavLink to="/" className={({ isActive }) => (isActive ? "link link-active" : "link")} onClick={handleLinkClick}>
              Inicio
            </NavLink>
          </li>
          
          <li className="dropdown">
            <NavLink 
              to="/productos" 
              className={({ isActive }) => (isActive ? "link link-active" : "link")} 
              onClick={handleProductsClick}
            >
              Productos 
              <span className={`arrow-down ${productsMenuOpen ? 'open' : ''}`}>▼</span>
            </NavLink>
            <ul className={`dropdown-menu ${productsMenuOpen ? 'mobile-open' : ''}`}>
              {productos.map((producto) => (
                <li key={producto.path}>
                  <NavLink to={producto.path} onClick={handleLinkClick}>
                    {producto.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </li>

          <li>
            <NavLink to="/clientes" className={({ isActive }) => (isActive ? "link link-active" : "link")} onClick={handleLinkClick}>
              Clientes
            </NavLink>
          </li>

          <li>
            <NavLink to="/blog" className={({ isActive }) => (isActive ? "link link-active" : "link")} onClick={handleLinkClick}>
              Blog
            </NavLink>
          </li>

          <li>
            <NavLink to="/contacto" className={({ isActive }) => (isActive ? "link link-active" : "link")} onClick={handleLinkClick}>
              Contacto
            </NavLink>
          </li>
          
        </ul>
        
        <button 
          className={`hamburger-menu ${menuOpen ? "active" : ""}`} 
          onClick={() => setMenuOpen(!menuOpen)} 
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </nav>

      <Link to="/contacto" className="whatsapp-icon">
        <img src="/Assets/icons/Whatsapp Form.svg" alt="Logo WhatsApp" title="Logo WhatsApp"/>
      </Link>
    </header>
  );
}

export default Header;